import {jsclj, resolveGoogExport} from 'dgetz/tsclj'

interface CheckboxSliderProps {
    onChange: Function;
    checked: boolean;
}
export function CheckboxSlider({checked, onChange} : CheckboxSliderProps) {
    const {checkbox_slider} = resolveGoogExport('ladder.ux.checkbox');
    return checkbox_slider(jsclj({
        'on-change': onChange,
        checked
    }))
}
